import PropTypes from 'prop-types';
import { useState } from 'react';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css'; // For some basic styling. (OPTIONAL)
// @mui
import { Box, Dialog, DialogTitle, Typography, Stack, styled } from '@mui/material';
import Iconify from './Iconify';
import useLocales from '../hooks/useLocales';
import { ThemeButton } from '../layouts/GlobalStyles';

// ----------------------------------------------------------------------

CustomDateRangePicker.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setDateRange: PropTypes.func,
  dateRange: PropTypes.object,
};

// ----------------------------------------------------------------------

const ButtonText = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '12px',
  zIndex: 1,
}));

export default function CustomDateRangePicker({ open, setOpen, setDateRange, dateRange }) {
  const { translate } = useLocales();

  const [customDateRange, setCustomDateRange] = useState(null);

  const onSelect = (dates) => {
    console.log(`dates = ${JSON.stringify(dates)}`);
    setCustomDateRange(dates);
  };

  const handleConfirm = () => {
    setDateRange({ ...customDateRange });
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          background: '#970300',
          width: 'auto',
          p: 1.5,
          borderRadius: '5px !important',
          margin: 0,
        },
      }}
    >
      <DialogTitle>{translate('choose_date')}</DialogTitle>

      <Iconify
        icon={'iconamoon:close-light'}
        sx={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer' }}
        width={35}
        height={35}
        onClick={() => setOpen(false)}
      />

      <Box>
        <DateRangePicker
          onSelect={onSelect}
          singleDateRange={true}
          numberOfCalendars={1}
          selectionType="range"
          value={customDateRange}
          className="custom-daterange"
        />
      </Box>

      <Stack direction="row" spacing={1} alignItems="center">
        <ThemeButton onClick={() => setOpen(false)} sx={{ flex: 1 }}>
          <ButtonText>{translate('cancel')}</ButtonText>
        </ThemeButton>
        <ThemeButton onClick={() => handleConfirm()} sx={{ flex: 1 }}>
          <ButtonText>{translate('confirm')}</ButtonText>
        </ThemeButton>
      </Stack>
    </Dialog>
  );
}
